import { Link, useLocation } from "react-router-dom";
import { BarChart3 } from "lucide-react";

/**
 * A small persistent footer with legal links that appears on every page.
 * Hidden on the legal pages themselves.
 */
export default function GlobalFooter() {
  const { pathname } = useLocation();
  return (
    <footer
      data-testid="global-footer"
      className="w-full border-t border-white/10 bg-[#06070A]/95 backdrop-blur mt-auto"
    >
      <div className="max-w-6xl mx-auto px-6 py-3 flex items-center justify-between text-[10px] font-mono tracking-widest uppercase text-[#64748B]">
        <span>© ModNode Productions</span>
        <div className="flex items-center gap-5">
          {pathname !== "/stats" && (
            <Link
              to="/stats"
              data-testid="global-stats-btn"
              className="flex items-center gap-1.5 px-3 py-1 border border-[#8B5CF6]/50 text-[#8B5CF6] hover:bg-[#8B5CF6] hover:text-white transition-colors"
            >
              <BarChart3 className="w-3 h-3" /> ModNode Stats
            </Link>
          )}
          <Link
            to="/tos"
            data-testid="global-tos-link"
            className="text-[#94A3B8] hover:text-[#8B5CF6] transition-colors"
          >
            Terms of Service
          </Link>
          <Link
            to="/privacy"
            data-testid="global-privacy-link"
            className="text-[#94A3B8] hover:text-[#10B981] transition-colors"
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  );
}
